export default "__VITE_ASSET__7SbtfowOfna6rPBRW7pgxg__"